import { animationOpacityIn } from 'style'
import { CSSProps } from 'style'

import Avatar from 'components/atomic/atoms/avatar'
import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import { TwitterIcon } from 'components/atomic/atoms/icons/logos/twitter'
import Text from 'components/atomic/atoms/text'

import { twitterReviews } from 'data/community/twitter-reviews'

type TwitterWidgetProps = (typeof twitterReviews)[0] & {
  media?: {
    url: string
    width: number
    height: number
  } & CSSProps
}

/**
 * Need to be improved:
 * - media should be an array of media objects
 * - use a twitter api instead of static tweets?
 * @see https://blog.maximeheckel.com/posts/static-tweets-with-mdx-nextjs/
 */
const TwitterWidget = (props: TwitterWidgetProps) => {
  const { text, imageSrc, name, twitter, link, media, date } = props

  const htmlString = text.replace(
    /([@|#][^,.\s]+)/gi, // e.g. match @username or #hashtag
    match => `<span>${match}</span>`,
  )
  const twitterUrl = `https://twitter.com/${twitter}`

  return (
    <Box
      data-widget="twitter"
      css={{
        p: '$6',
        mx: 'auto',
        maxWidth: 418,
        border: '1px solid $bg3',
        borderRadius: '$xl',
        bgc: '$base',
        animation: animationOpacityIn,
      }}
    >
      <Box flex items="center" justify="between">
        <Box
          as="a"
          href={twitterUrl}
          target="_blank"
          rel="noreferrer"
          flex
          items="center"
          css={{
            spaceX: 2,
            fontWeight: '$regular !important',
          }}
        >
          <Avatar src={imageSrc} size="lg" />
          <Box flex="column">
            <Text color="text1" size="sm">
              {name}
            </Text>
            <Text color="text3" size="xs">
              @{twitter}
            </Text>
          </Box>
        </Box>
        <Text as="a" href={link} target="_blank" rel="noopener">
          <IconStyled as={TwitterIcon} color="text1" size="2xl" />
        </Text>
      </Box>
      <Text
        as="p"
        color="text2"
        css={{
          mt: '$6',
          whiteSpace: 'break-spaces',
          span: { color: '$secondary' },
          a: {
            color: '$secondary !important',
            '&:hover': {
              color: '$secondaryHover !important',
            },
          },
        }}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
      {!!media?.url && (
        <Box relative css={{ mt: '$6', ...media.css }}>
          <Box
            as="img"
            src={media.url}
            width={media.width}
            height={media.height}
            alt={`image by ${name}`}
            relative
            css={{ borderRadius: '$md' }}
          />
        </Box>
      )}
      <Box css={{ mt: '$2' }}>
        <Text
          as="a"
          href={link}
          target="_blank"
          rel="noopener"
          size="xs"
          underlineHover
          css={{
            color: '$text3 !important',
          }}
        >
          {date}
        </Text>
      </Box>
    </Box>
  )
}

export default TwitterWidget
